import { useState } from 'react';
import _ from 'lodash';
import { useAuthenticationStore } from './Authentication';
import { makeRequest, fetchBaseUrl, processResponse } from './Ajax';
import { buildFormData } from '../../lib/UtilityHelper';

export function useProviderHelpers() {
    const [data, setData] = useState();

    const { fetchAuthData } = useAuthenticationStore();

    // These fields are passed in by validation controls.  They should be ignored and not passed to server
    const ignoredFields = ['ignore_whitespace', 'protocols', 'require_tld', 'require_protocol', 'require_host', 'require_valid_protocol', 'allow_underscores',
        'allow_trailing_dot', 'allow_protocol_relative_urls', 'allow_display_name', 'require_display_name', 'allow_utf8_local_part'];

    const fetchAuthorizationHeaders = () => {
        const authData = fetchAuthData();

        if (!_.isEmpty(authData) && !_.isEmpty(authData.accessToken)) {
            return { "Authorization": `Bearer ${authData.accessToken}` };
        }
    };

    const clearData = () => {
        setData(null);
    };

    const setResult = (props) => {
        setData({ status: 'success', scope: props.scope, statusCode: 200, body: props.body });
    };

    const execute = async (props) => {
        const base_url = fetchBaseUrl();
        let result = null;

        setData({ status: 'processing', scope: props.scope, result: null });

        let headers = (props.secure) ? { ...props.headers, ...fetchAuthorizationHeaders() } : props.headers;
        let payload = props.payload;

        if (!_.isEmpty(payload)) {
            Object.keys(payload).forEach((key) => {
                if (_.includes(ignoredFields, key)) {
                    delete payload[key];
                }
            });
        }

        if (props.multipart) {
            let formData = new FormData();
            if (payload) {
                buildFormData(formData, payload);
            }

            payload = formData;
        }

        try {
            // Handle cached data
            if (props.cached && props.cachedData) {
                setData({ status: 'success', scope: props.scope, statusCode: 200, body: props.cachedData });
                return;
            }

            if (!_.isEmpty(props.url)) {
                var response = await makeRequest({ url: `${base_url}/${props.url}`, method: props.method, payload: payload, headers: headers, multipart: props.multipart });
                result = processResponse(response);

                if (!_.isEmpty(result) && result.status === 200) {
                    setData({ status: 'success', scope: props.scope, statusCode: result.status, body: result.body });

                    return {
                        success: true,
                        data: result.body,
                    };
                } else {
                    setData({ status: 'fail', scope: props.scope, statusCode: result.status, body: result.message });
                    return {
                        success: false,
                        message: result.message,
                    };
                }
            } else {
                setData({ status: 'success', scope: props.scope, statusCode: 200, body: null });
            }
        } catch {
            setData({ status: 'error', scope: props.scope, statusCode: 500, body: { message: 'Oops! Something went wrong!' } });

            return {
                success: false,
                message: 'Oops! Something went wrong!',
            };
        }
    };

    return { data, clearData, execute, setResult };
}